// 访问统计工具
import request from './request'

class VisitTracker {
  constructor() {
    this.sessionId = this.generateSessionId()
    this.isTracked = false
  }

  // 生成会话ID
  generateSessionId() {
    return 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9)
  }

  // 记录首页访问（只在首次访问首页时调用）
  trackHomepageVisit() {
    if (this.isTracked) return
    
    this.trackVisit()
    this.isTracked = true
  }

  // 记录访问
  async trackVisit() {
    try {
      const pageUrl = window.location.href
      const visitData = {
        page_url: pageUrl,
        visit_type: 'web',
        session_id: this.sessionId,
        timestamp: new Date().toISOString()
      }

      // 发送访问记录
      await request({
        url: '/visits/track',
        method: 'post',
        data: visitData
      })
    } catch (error) {
      console.warn('访问统计记录失败:', error)
    }
  }

  // 记录页面浏览
  trackPageView(pageName) {
    try {
      const pageUrl = window.location.href
      const visitData = {
        page_url: pageUrl,
        visit_type: 'web',
        session_id: this.sessionId,
        page_name: pageName,
        timestamp: new Date().toISOString()
      }

      request({
        url: '/visits/track',
        method: 'post',
        data: visitData
      }).catch(error => {
        console.warn('页面浏览统计记录失败:', error)
      })
    } catch (error) {
      console.warn('页面浏览统计记录失败:', error)
    }
  }
}

// 创建全局实例
const visitTracker = new VisitTracker()

export default visitTracker

